import React from 'react';
import LoginForm from './components/LoginForm';

const Login = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 flex items-center justify-center p-4 sm:p-6">
      {/* Minimalist Centered Card */}
      <div className="w-full max-w-md">
        {/* Logo/Brand - Centered Above Card */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center gap-3 mb-3">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl blur-xl opacity-40 animate-pulse"></div>
              <div className="relative p-3 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl shadow-lg">
              </div>
            </div>
            <h1 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
              CTOBRA
            </h1>
          </div>
          <p className="text-sm sm:text-base text-slate-600 font-medium">
            Sistema de Gestão de Obras e Projetos
          </p>
        </div>

        {/* Login Card - Clean and Centered */}
        <div className="bg-white/80 backdrop-blur-lg rounded-3xl shadow-2xl border border-white/50 p-8 sm:p-10">
          <LoginForm />
        </div>

        {/* Footer */}
        <div className="text-center mt-6 text-xs sm:text-sm text-slate-500">
          <p>&copy; {new Date()?.getFullYear()} CTOBRA. Todos os direitos reservados.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;